import { RouteConfig } from 'vue-router';
import Availability from '../../apps/availability/Availability.vue';
import { requireProvider } from '@/router/guards/authGuards';

const availabilityRoutes: RouteConfig[] = [
  {
    path: '/availability',
    name: 'Availability',
    component: Availability,
    beforeEnter: requireProvider,
  },
];

export default availabilityRoutes;
